import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";
import { BuiltInType } from '@iconics/providers.fadx-platform-api-client-v2';

export class Package extends ODataSelect
{
    public Id = '';
    public Name = '';
    public DisplayName = '';
    public Description = '';
    public IsEnabled = false;
    public '@odata.etag' = '';

    public init(response: any): ODataSelect
    {
        Object.assign(this, response);
        this.IsEnabled = TypeHelper.toBoolean(response.IsEnabled) ?? false;
        return this;
    }

    public toSelect(): string
    {
        return '';
    }
}

export class Solution extends ODataSelect
{
    public Id = '';
    public Name = '';
    public Description = '';
    public IsEnabled = false;
    public '@odata.etag' = '';

    public init(response: any): ODataSelect
    {
        Object.assign(this, response);
        this.IsEnabled = TypeHelper.toBoolean(response.IsEnabled) ?? false;
        return this;
    }

    public toSelect(): string
    {
        return '';
    }
}

export class Entity extends ODataSelect
{
    public Id = 0;
    public Name = "";
    public DisplayName: string | null = "";
    public StorageType = "";
    public HistoryStorageMethod = "";
    public AuditLogDisabled = false;

    public init(response: any): ODataSelect
    {
        Object.assign(this, response);
        this.AuditLogDisabled = TypeHelper.toBoolean(response.AuditLogDisabled) ?? false;
        return this;
    }

    public toSelect(): string
    {
        return '';
    }
}

export class Attribute extends ODataSelect
{
    public Id = 0;
    public Name = '';
    public BuiltInType: BuiltInType | '' = '';
    public IsArray: boolean | null = null;
    public IsMandatory: boolean | null = null;
}
